// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__wMDus","vLegacy":"SelectSecondary_vLegacy__1DSqw","error":"SelectSecondary_error__pKCuu","disabled":"SelectSecondary_disabled__24-2U"};